import { RootState } from 'store/rootReducer';

export const selectGetCustomers = (state: RootState) => state.customers.base.getCustomersState;
export const selectCustomerById = (state: RootState) => state.customers.base.customerByIdState;
